export default __webpack_public_path__ + "static/media/zapier-logo.e2639c29.svg";